export const INTEGRATION_UI_STYLING_OPTIONS_TOKEN = 'INTEGRATION_UI_STYLING_OPTIONS';

export interface IntegrationUiStylingOptions {
  backgroundColor?: string;
  backgroundColorSecondary?: string;
}
